var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5001,
    cy: 8.49998,
    r: 7.15,
    stroke: "#9B9B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78939 9.45172L9.26384 9.1301C10.4442 8.3605 10.8376 7.71726 10.8376 6.8328C10.8376 5.71861 10.016 4.67334 8.48853 4.67334C7.1462 4.67334 6.1626 5.56929 6.1626 6.21253C6.1626 6.52266 6.34775 6.78685 6.74119 6.78685C7.28506 6.78685 7.48178 5.9828 8.4191 5.9828C8.99768 5.9828 9.41427 6.37334 9.41427 6.9132C9.41427 7.39564 9.18283 7.71726 8.6621 8.06185L8.14137 8.41793C7.80579 8.64766 7.6785 9.01523 7.86365 9.31388C8.07194 9.61253 8.46538 9.65847 8.78939 9.45172ZM8.48853 12.3233C8.99768 12.3233 9.41427 11.9213 9.41427 11.4159C9.41427 10.9105 8.99768 10.497 8.48853 10.497C7.97937 10.497 7.57435 10.9105 7.57435 11.4159C7.57435 11.9213 7.97937 12.3233 8.48853 12.3233Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.127965e2409f529edc79e1887d424db7.svg";
export { ForwardRef as ReactComponent };